export default __webpack_public_path__ + "static/media/avatar4.11b7073a.svg";